import {
  collectionGroup,
  getDocs,
  query,
  where,
  Timestamp,
} from "firebase/firestore";
import { db } from "../config/firebase";

export const getTopCommentsThisWeek = async () => {
  const oneWeekAgo = Timestamp.fromDate(
    new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
  );

  const movieCommentsQuery = query(
    collectionGroup(db, "comments"),
    where("createdAt", ">=", oneWeekAgo)
  );

  try {
    const snapshot = await getDocs(movieCommentsQuery);
    const comments = [];

    snapshot.forEach((doc) => {
      const data = doc.data();
      comments.push({
        id: doc.id,
        ...data,
        upvotesCount: data.upvotes?.length || 0,
        path: doc.ref.path, // optional for linking back to detail page
      });
    });

    // Sort by upvotes first, then by recency (newest first)
    const sorted = comments
      .sort((a, b) => {
        if (b.upvotesCount === a.upvotesCount) {
          return b.createdAt.toDate() - a.createdAt.toDate(); // newest first
        }
        return b.upvotesCount - a.upvotesCount; // highest upvotes first
      })
      .slice(0, 10); // Top 10

    return sorted;
  } catch (err) {
    console.error("Error fetching top comments:", err);
    return [];
  }
};
